import { FETCHED_CATEGORIES } from '../actions';

const defaultState = {
  categories: {
    data: [],
    pagination: null,
  },
};

const shoppingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCHED_CATEGORIES:
      state = { ...state, categories: action.payload };
      break;

    default:
      break;
  }

  return state;
};

export { shoppingReducer };
